import React, {useRef, useState} from "react";
import HrnbLink from "./HrnbLink";
import HrnbButton from "./HrnbButton";
import HrnbNavbarPopup from "./HrnbNavbarPopup";
import HrnbNavbarDropdown from "./HrnbNavbarDropdown";
import "../../css/components/controls/HrnbNavbar.css";
import {CabinetIcon, LoginIcon} from "../../icons";
import AuthPopup from "../auth/AuthPopup";

export default function HrnbNavbar({ links = [], dropdowns = [], logo, user, onLogout, onLogin, extra, userMenuExtraItems = [] }) {
    const [isAuthPopupOpen, setIsAuthPopup] = useState(false)
    const [userMenuOpen, setUserMenuOpen] = useState(false)
    const userBtnRef = useRef(null)

    const userMenuItems = user
        ? [
            { to: "/cabinet", label: "Кабинет", icon: <CabinetIcon /> },
            ...userMenuExtraItems,
        ]
        : [];

    return (
        <nav className="hrnb-navbar">
            <div className="hrnb-navbar__container">
                {/* Логотип */}
                {logo && (
                    <HrnbLink to="/" className="hrnb-navbar__logo">
                        {logo}
                    </HrnbLink>
                )}

                {/* Навигационные ссылки */}
                <ul className="hrnb-navbar__links">
                    {links.map(link => (
                        <li key={link.to}>
                            <HrnbLink
                                to={link.to}
                                icon={link.icon}
                                className={`hrnb-navbar__link ${
                                    link.active ? "hrnb-navbar__link--active" : ""
                                }`}
                            >
                                {link.label}
                            </HrnbLink>
                        </li>
                    ))}
                    {/* Dropdown меню */}
                    {dropdowns.map((dropdown, index) => (
                        <li key={dropdown.label || index}>
                            <HrnbNavbarDropdown
                                label={dropdown.label}
                                icon={dropdown.icon}
                                items={dropdown.items}
                            />
                        </li>
                    ))}
                </ul>

                {/* Пользовательское меню */}
                {user ? (
                    <div className="hrnb-navbar__user">
                        <HrnbButton
                            ref={userBtnRef}
                            className="hrnb-navbar__user-btn"
                            variant="ghost"
                            icon={<CabinetIcon />}
                            onClick={() => setUserMenuOpen(s => !s)}
                        >
                            {user.displayName || user.username}
                        </HrnbButton>
                        <HrnbNavbarPopup
                            anchorRef={userBtnRef}
                            isOpen={userMenuOpen}
                            onClose={() => setUserMenuOpen(false)}
                            items={userMenuItems}
                            user={user}
                            onLogout={onLogout}
                            extra={extra}
                            align="right"
                        />
                    </div>
                ) : (
                    <HrnbLink
                        icon={<LoginIcon />}
                        onClick={(e)=>{
                            e.preventDefault();
                            setIsAuthPopup(true);}}
                        className="hrnb-navbar__link"
                    >
                        Войти
                    </HrnbLink>
                )}

                <AuthPopup
                    isOpen={isAuthPopupOpen}
                    onClose={() => setIsAuthPopup(false)}
                />
            </div>
        </nav>
    );
}
